/**
 * Marketing Page Shimmer Initialization
 * Handles dynamic shimmer loading for analyst directory/marketing pages
 */

/* global $, INFORMA */

// Wait for DOM and dependencies to be ready
function initMarketingShimmer() {
    var shimmerShown = false;
    var resultsCheckInterval = null;
    var fallbackTimeout = null;

    // Function to get current page size from dropdown
    function getPageSize() {
        var pageSizeSelect = $('select[ng-model="pageSize"]');
        if (pageSizeSelect.length > 0) {
            var selectedValue = pageSizeSelect.find('option:selected').val() || 
                              pageSizeSelect.val();
            if (selectedValue) {
                return parseInt(selectedValue, 10);
            }
        }
        return 50; // default page size
    }

    // Function to show shimmer with dynamic row count
    function showShimmer() {
        // Check dependencies
        if (typeof $ === 'undefined' || 
            !window.INFORMA || 
            !window.INFORMA.Shimmer ||
            !$('body').hasClass('theme-omdia')) {
            console.warn('⚠️ Shimmer: Dependencies not ready');
            return;
        }

        var resultsContainer = $('.shimmer_marketing_container').first();

        if (resultsContainer.length === 0) {
            console.warn('⚠️ Shimmer: Container not found (.shimmer_marketing_container)');
            return;
        }

        var pageSize = getPageSize();

        console.log('✅ Shimmer: Showing ' + pageSize + ' shimmer cards');
        
        window.INFORMA.Shimmer.Show(resultsContainer, {
            rows: pageSize,
            type: 'card',
            minDisplayTime: 2000
        });
        
        shimmerShown = true;

        // Clear any existing intervals
        if (resultsCheckInterval) {
            clearInterval(resultsCheckInterval);
        }
        if (fallbackTimeout) {
            clearTimeout(fallbackTimeout);
        }

        // Watch for Angular to render results
        resultsCheckInterval = setInterval(function () {
            var hasResults = resultsContainer.find('[ng-repeat]').length > 0 || 
                           resultsContainer.find('.inf-col-fluid').length > 0;

            if (hasResults) {
                console.log('✅ Shimmer: Results detected, hiding shimmer');
                clearInterval(resultsCheckInterval);
                setTimeout(function () {
                    window.INFORMA.Shimmer.Hide();
                    shimmerShown = false;
                }, 500); // Small delay for smooth transition
            }
        }, 500); // Check every 500ms

        // Fallback: Hide after 10 seconds max
        fallbackTimeout = setTimeout(function () {
            clearInterval(resultsCheckInterval);
            if (shimmerShown) {
                console.log('⏱️ Shimmer: Timeout reached, hiding shimmer');
                window.INFORMA.Shimmer.Hide();
                shimmerShown = false;
            }
        }, 10000);
    }

    // Initial shimmer show on page load
    setTimeout(function () {
        showShimmer();

        // Listen for page size changes
        $(document).on('change', 'select[ng-model="pageSize"]', function () {
            var newPageSize = $(this).val();
            console.log('📊 Page size changed to: ' + newPageSize);

            // Show shimmer again with new page size
            setTimeout(function () {
                showShimmer();
            }, 100);
        });

    }, 100); // Small delay to ensure everything is loaded
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarketingShimmer);
} else {
    initMarketingShimmer();
}
